import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Card, Col, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PaginationComponent,
} from "../../../components/Component";
import { TicketTable } from "../../../components/table/SpecialTable";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

export const OpenTicketsManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingViewData, setIsLoadingViewData] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [itemPerPage] = useState(10);
  const [modal, setModal] = useState({ view: false });
  const [tickets, setTickets] = useState([]);
  const [replies, setReplies] = useState([]);
  const [currentTicketId, setCurrentTicketId] = useState("");
  const [formData, setFormData] = useState({
    content: "",
  });
  const selectedImages = [];
  const [search, setSearch] = useState("");
  const [isClosingTicket, setIsClosingTicket] = useState(false);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllOpenTickets();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getAllOpenTickets = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/feedback/open-tickets?admin-usage=ADMIN_TREASURY&platform=TREASURY&search=${search}`,
        {
          headers: authHeader(),
        }
      );
      const { data } = response;
      if (data) {
        setTickets(data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      content: "",
    });
  };

  const onFormCancel = () => {
    setModal({ view: false });
    resetForm();
  };

  const closeTicket = async (id) => {
    try {
      setIsClosingTicket(true);
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/feedback/close-ticket/${id}?platform=TREASURY`,
        {},
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        getAllOpenTickets();
        setIsClosingTicket(false);
        setIsLoading(false);
        setModal({ edit: false });
        // resetForm();
        message.success(formData.message);
      }
      return { formData };
    } catch (error) {
      setIsClosingTicket(false);
      setIsLoading(false);
      setModal({ edit: false });
      message.error(error.response.data.message);
      return { errorMsg: error.response.data.message };
    }
  };

  const getSingleTicketById = async (id) => {
    try {
      setIsLoadingViewData(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/feedback/${id}?platform=TREASURY`,
        {
          headers: authHeader(),
        }
      );
      if (response.data) {
        setSelectedTicket(response.data);
        setIsLoadingViewData(false);
      }
      // return { formData };
    } catch (error) {
      setIsLoading(false);
      setIsLoadingViewData(false);
      // setModal({ view: false });
      message.error(error.response.data.message);
      return { errorMsg: error.response.data.message };
    }
  };
  //
  const getSingleTicketReplies = async (id) => {
    try {
      setIsLoadingViewData(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/feedback/ticket-reply/${id}`, {
        headers: authHeader(),
      });
      if (response.data) {
        setReplies(response.data);
        setIsLoadingViewData(false);
      }
      // return { formData };
    } catch (error) {
      setIsLoading(false);
      setIsLoadingViewData(false);
      // setModal({ view: false });
      message.error(error.response.data.message);
      return { errorMsg: error.response.data.message };
    }
  };

  const sendReply = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/feedback/reply-ticket`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllOpenTickets();
        getSingleTicketReplies(formData.data.ticket.id);
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
        message.success(formData.message);
      }
      return { formData };
    } catch (error) {
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      message.error(error.response.data.message);
      return { errorMsg: error.response.data.message };
    }
  };

  const handleReplySend = () => {
    sendReply({
      ...formData,
      images: selectedImages,
      ticketId: selectedTicket.id,
      title: new Date().toISOString(),
      platform: "TREASURY",
    });
    resetForm();
  };

  const handleView = (item) => {
    getSingleTicketById(item.id);
    getSingleTicketReplies(item.id);
    setCurrentTicketId(item?.id);
    setModal({ view: true });
  };

  const handleCloseTicket = (item) => {
    closeTicket(item.id);
  };

  useEffect(() => {
    getAllOpenTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = tickets?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const { errors, register, handleSubmit } = useForm();

  return (
    <React.Fragment>
      <Head title="Open Tickets" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Open Tickets</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Ticket..."
                    />
                  </div>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <TicketTable
                data={currentItems}
                modal={modal}
                handleView={handleView}
                handleCloseTicket={handleCloseTicket}
              />
            )}
          </Card>
          <div className="card-inner">
            {tickets && tickets.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={tickets?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Tickets found</span>
              </div>
            )}
          </div>
        </Block>
        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            {isLoadingViewData ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : selectedTicket !== null ? (
              <div className="p-2">
                <h5 className="title">View Ticket: {selectedTicket.title}</h5>
                <div className="mt-4">
                  <Form className="row gy-4" onSubmit={handleSubmit(handleReplySend)}>
                    <Col md="12" className="w-100 bg-gray d-flex rounded text-white">
                      <Col md="6">
                        <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                          {selectedTicket?.company !== null ? "Company Name" : "Customer Name"}:
                        </span>
                        <span style={{ fontSize: "0.9rem" }}>
                          {selectedTicket?.company?.name ?? `${selectedTicket?.customerName}`}
                        </span>
                      </Col>
                      <Col md="6">
                        <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                          Ticket Category:
                        </span>
                        <span style={{ fontSize: "0.9rem" }}>{selectedTicket?.category?.name} </span>
                      </Col>
                    </Col>
                    <Col md="12" className="overflow-auto" style={{ maxHeight: "100%" }}>
                      {replies.map((reply) => (
                        <div
                          className={`d-flex w-100 ${reply.replyType === "ADMIN_REPLY" ? "justify-content-end" : ""}`}
                        >
                          <div
                            key={reply.id}
                            className={`${
                              reply.replyType === "USER_REPLY" ? "bg-primary" : "bg-info"
                            } p-2 my-1 text-white`}
                            style={{
                              maxWidth: "50%",
                              borderRadius: "1rem",
                              borderBottomLeftRadius: reply.replyType === "USER_REPLY" ? "0px" : "1rem",
                              borderBottomRightRadius: reply.replyType === "ADMIN_REPLY" ? "0px" : "1rem",
                            }}
                          >
                            <div className="w-100">
                              <p>{reply.content}</p>
                              <p style={{ fontSize: "0.6rem" }} className="text-white m-0 p-0 text-right">
                                {reply.createdAt}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Col>
                    <Col md="12">
                      <FormGroup className="d-flex justify-content-between align-items-center">
                        <Col md="10" className="p-0">
                          <input
                            style={{ height: "3rem" }}
                            type="text"
                            name="content"
                            placeholder="Enter Message"
                            onChange={(e) => onInputChange(e)}
                            className="form-control h-12"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.content && <span className="invalid">{errors.content.message}</span>}
                        </Col>
                        <Col md="1" className="p-0">
                          <Button color="primary" size="md" type="submit" style={{ height: "3rem" }}>
                            {isLoadBtn ? <Spinner size="sm" /> : <Icon name="send" />}
                          </Button>
                        </Col>
                      </FormGroup>
                      <Col md="12" className="d-flex justify-content-end p-0">
                        <Button
                          onClick={() => handleCloseTicket({ id: currentTicketId })}
                          color="warning"
                          size="md"
                          className="w-25 d-flex align-items-center justify-content-center text-center"
                        >
                          {isClosingTicket ? <Spinner size="md" /> : "Close Ticket"}
                        </Button>
                      </Col>
                    </Col>
                  </Form>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <span className="text-silent">Cannot Load Ticket</span>
              </div>
            )}
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
